import { Bold } from '@panwds/react-ui'
import { SubTenant, TenantIllustration, TenantTree } from '../../assets'

type TenantDataType = {
  title: string
  text: string
  image: string
}

const tenantData: TenantDataType[] = [
  {
    title: 'What is a tenant?',
    text: 'A tenant is a logical container for a group (e.g., company, business unit, region, or geographical location) where you can separately manage and monitor the products and licenses in a subscription. An admin can see products and data in their own tenant and all of its subtenants.',
    image: TenantIllustration
  },
  {
    title: 'What is a sub-tenant?',
    text: 'Any tenant nested under another tenant is its subtenant. You can add subtenants to separately manage and monitor products and licenses in the same hierarchy, such as for subsidiaries or business units.',
    image: SubTenant
  },
  {
    title: 'Can I create more tenants/sub-tenants?',
    text: 'A subscription gets activated on a single tenant or subtenant. After it\'s active and provisioned with the instances of your products, you can then build out your tenant hierarchy further as needed.',
    image: TenantTree
  }
]

const ULearnTenants = () => {
  return (
    <div className='cm-mt-4 cm-w-full'>
      <div className='tw-grid tw-grid-cols-3 tw-gap-4'>
        {tenantData.map((each, idx) => (
          <div key={idx} className='tw-p-3 tw-col-span-1 tw-bg-gray-100 dark:tw-bg-black'>
            <div className='tw-pb-2 tw-row-span-full'>
              <div className='tw-text-sm'> <Bold appearance="semibold">{each.title} </Bold></div>
            </div>
            <div className='tw-grid tw-grid-cols-3 tw-gap-4'>
              <div className='tw-col-span-2'>
                <div className='tw-text-xs tw-leading-5'> {each.text}</div>
              </div>
              <div className='tw-col-span-1'>
                <img src={each.image} alt='learn' className='tw-object-contain tw-w-full'/>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ULearnTenants
